import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores';
import { LoadingState } from '@/components/ui';
import { useSessionCheck } from './useSessionCheck';

interface AdminRouteProps {
  /** Wrapped element; without it the guard acts as a layout route. */
  children?: React.ReactNode;
}

/**
 * Admin Route - requires authentication AND the ADMIN role.
 * Unauthenticated users are sent to login, non-admins to the design overview.
 */
export function AdminRoute({ children }: AdminRouteProps) {
  const location = useLocation();
  const { t } = useTranslation();
  const { user, isAuthenticated, isLoading } = useAuthStore();
  const isChecking = useSessionCheck();

  if (isLoading || isChecking) {
    return <LoadingState fullscreen label={t('common.loading')} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/designs" replace />;
  }

  return children !== undefined ? <>{children}</> : <Outlet />;
}
